import { render, staticRenderFns } from "./TreatmentRecipeModal.vue?vue&type=template&id=0d39d019&scoped=true"
import script from "./TreatmentRecipeModal.vue?vue&type=script&lang=ts"
export * from "./TreatmentRecipeModal.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentRecipeModal.vue?vue&type=style&index=0&id=0d39d019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39d019",
  null
  
)

export default component.exports